<template>
  <div>
    <!-- <div class="notes">注: 以下页数按A4单面计算，双面、A3自动2倍，双色计入彩色</div> -->
    <Alert type="warning" style="width: 612px;padding-right: 16px;font-size:12px">
      提示：以下页数按A4单面计算，A3和双面将自动2倍A4，双色计入彩色
      <Button type="success" style="margin-left: 96px;" @click="openPdf">查看填写指引</Button>
    </Alert>
    <Form ref="formInline" :model="itemData" :rules="rule" :label-width="160" inline>
      <FormItem prop="name" label="方案名称:">
        <Input style="width:141px" v-model="data.name" placeholder="抄表结算方案名称"/>
      </FormItem>
      <FormItem prop="basics" label="基础金额(元):">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="data.basics"></InputNumber>
      </FormItem>
      <br/>
      <FormItem prop="black_num" label="免费黑白(页):">
        <InputNumber style="width:141px" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.black_num"></InputNumber>
      </FormItem>
      <FormItem prop="color_num" label="免费彩色(页):">
        <InputNumber style="width:141px" :active-change="false" :precision="0" :min="0" :step="1" v-model="itemData.color_num"></InputNumber>
      </FormItem>
      <br/>
      <FormItem prop="black_money" label="超出黑白单价(元/页):">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.black_money"></InputNumber>
      </FormItem>
      <FormItem prop="color_money" label="超出彩色单价(元/页):">
        <InputNumber style="width:141px" :active-change="false" :precision="2" :min="0" :step="1" v-model="itemData.color_money"></InputNumber>
      </FormItem>
      <br/>
      <FormItem label="结算方案描述">
        <Input style="width: 141px" v-model="data.describe"/>
      </FormItem>
      <br/>
      <FormItem style="margin-top:40px">
        <Button @click="$router.back()" style="margin-right:10px">取消</Button>
        <Button type="primary" @click="save"  v-preventReClick :loading="loading">确定</Button>
      </FormItem>
    </Form>
    <!-- <div class="formula">公式</div>
    <div class="formula-box">
      <div class="row">应收=基础金额 +（<span>黑白总数</span>-免费黑白）* 超出黑白单价 +（<span>彩色总数</span>-免费彩色）* 超出彩色单价</div>
      <div class="row">应收=基础金额 +（<span>总计数</span>-免费黑白）* 超出黑白单价</div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'type1',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      rule: {
        name: [{ validator: (rule, value, cb) => {
          if (!this.data.name) {
            cb(new Error('方案名称未填'))
          } else {
            cb()
          }
        },
        required: true,
        trigger: 'blur' }],
        basics: [{ validator: (rule, value, cb) => {
          if (this.data.basics >= 0) {
            cb()
          } else {
            cb(new Error('基础金额未填'))
          }
        },
        required: true,
        trigger: 'blur' }],
        black_num: [{ validator: (rule, value, cb) => {
          if (this.itemData.black_num >= 0) {
            cb()
          } else {
            cb(new Error('此项必填'))
          }
        },
        required: true,
        trigger: 'blur' }],
        color_num: [{ validator: (rule, value, cb) => {
          if (this.itemData.color_num >= 0) {
            cb()
          } else {
            cb(new Error('此项必填'))
          }
        },
        required: true,
        trigger: 'blur' }],
        black_money: [{ validator: (rule, value, cb) => {
          if (this.itemData.black_money >= 0) {
            cb()
          } else {
            cb(new Error('此项必填'))
          }
        },
        required: true,
        trigger: 'blur' }],
        color_money: [{ validator: (rule, value, cb) => {
          if (this.itemData.color_money >= 0) {
            cb()
          } else {
            cb(new Error('此项必填'))
          }
        },
        required: true,
        trigger: 'blur' }]
      },
      itemData: {
        black_num: 0,
        color_num: 0,
        black_money: 0,
        color_money: 0
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    openPdf () {
      window.open('https://www.aidprint.com/pdf/cg.pdf')
    },
    save () {
      this.$refs.formInline.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.data.agent_id = this.user.id
          this.data.content = JSON.stringify(this.itemData)
          this.data.type = '1'
          this.SaveMeterCharge(this.data).then(res => {
            if (res) {
              this.data.id = res
              this.$Message.success('保存成功')
            }
            this.loading = false
          })
        }
      })
    },
    initData () {
      if (this.data.id && this.data.type == 1) {
        this.itemData = JSON.parse(this.data.content)
      }
    },
    ...mapActions(['SaveMeterCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  })
}
</script>

<style lang="less" scoped>
  @import '../index.less';
</style>
